import React from 'react';

import TFIActions from 'notebook/tfi/TFIActions';
import {TFIAccount} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import LegacyDropdownMenu from 'ui-library/dropdowns/LegacyDropdownMenu';
import SettingsIcon from 'ui-library/icons/SettingsIcon';
import * as modals from 'util/Modals';

interface Props {
  accounts?: Array<TFIAccount> | null;
}

interface State {
  isDropdownOpen: boolean;
}

class TFISettingsIcon extends React.Component<Props, State> {
  override state: State = {
    isDropdownOpen: false,
  };

  private handleOpenDropdown = (): void => {
    this.setState({isDropdownOpen: true});
  };

  private handleCloseDropdown = (): void => {
    this.setState({isDropdownOpen: false});
  };

  deleteAccount = (account: TFIAccount): void => {
    modals
      .confirm(
        'Unlink Account',
        <div>
          <p>
            Are you sure you want to unlink your
            {` ${TFIUtil.readableAccountType(account.accountType)} `}
            account <strong>{account.name}</strong>?
          </p>
          <p>
            All files you've imported from the account into Benchling projects will remain there, but you'll
            lose the ability to resync them.
          </p>
        </div>,
        'success',
        {
          acceptText: 'Yes, unlink',
          rejectText: 'No, never mind',
        }
      )
      .done(TFIActions.deleteAccount.bind(null, account.id));
  };

  override render(): JSX.Element | null {
    if (!this.props.accounts || this.props.accounts.length === 0) {
      return null;
    }
    const options = this.props.accounts.map((account) => ({
      name: `Unlink ${TFIUtil.readableAccountType(account.accountType)}`,
      handleOnClick: this.deleteAccount.bind(null, account),
    }));
    return (
      <AbsoluteDropdownContainer
        onRequestClose={this.handleCloseDropdown}
        open={this.state.isDropdownOpen}
        menu={<LegacyDropdownMenu items={[options]} />}
        shouldCloseOnInsideClick={true}
      >
        <SettingsIcon className="u-small-spacing-left" onClick={this.handleOpenDropdown} />
      </AbsoluteDropdownContainer>
    );
  }
}

export default TFISettingsIcon;
